<template>
    <data-section
      theme="blue"
      title="其他保單筆記"
      :isLoading="isLoading"
      :datas="highlightModify"
      :_fields="
        [
          {
            name: '編號',
            key: 'ceplcno',
            width: 100,
            sortable: true,
            orderByMultiKey: ['ceplcno'],
            orderByMultiType: ['asc']
          },
          {
            name: '公司',
            key: 'comp_nm',
            width: 100,
            sortable: true,
            orderByMultiKey: ['comp_nm'],
            orderByMultiType: ['asc']
          },
          {
            name: '契約別',
            key: 'contract_type_nm',
            width: 80,
            sortable: true,
            orderByMultiKey: ['contract_type_nm'],
            orderByMultiType: ['asc']
          },
          {
            name: '被保人',
            key: 'ceisdnm',
            width: 80,
            sortable: true,
            className: 'link text-underline',
            orderByMultiKey: ['ceisdnm'],
            orderByMultiType: ['asc']
          },
        //   {
        //     name: '險種',
        //     key: 'contract_type',
        //     width: 80,
        //     sortable: true,
        //     orderByMultiKey: ['contract_type'],
        //     orderByMultiType: ['asc']
        //   },
          {
            name: '投保日期',
            key: 'ceplcdt',
            width: 80,
            sortable: true,
            className: 'text-left',
            orderByMultiKey: ['ceplcdt'],
            orderByMultiType: ['asc']
          },
          {
            name: '投保年期',
            key: 'prd',
            width: 80,
            sortable: true,
            className: 'text-left',
            orderByMultiKey: ['prd'],
            orderByMultiType: ['asc']
          },
          {
            name: '保額',
            key: 'famt',
            width: 80,
            thClassName: 'text-right',
            className: 'text-right',
            sortable: true,
            orderByMultiKey: ['famt'],
            orderByMultiType: ['asc']
          },
          {
            name: '保費',
            key: 'premium',
            width: 80,
            thClassName: 'text-right',
            className: 'text-right',
            sortable: true,
            orderByMultiKey: ['premium'],
            orderByMultiType: ['asc']
          },
          {
            name: '備註',
            key: 'remark',
            width: 120,
            thClassName: 'text-left',
            className: 'text-left',
            sortable: true,
            orderByMultiKey: ['remark'],
            orderByMultiType: ['asc']
          }
        ].concat(_fields)
      "
      @toggle="
        (isShow) => $router.assignQuery({ OtherPropertyInsuranceNoteShow: isShow })
      "
      :initShow="$route.query['OtherPropertyInsuranceNoteShow'] !== 'false'"
    >
      <template scope="props"  v-if="refresh">
        <data-table
          class="mt-3"
          v-bind="props"
          @changeSort="
            (sort) =>
              $router.assignQuery({
                [`OtherPropertyInsuranceNoteSort`]: JSON.stringify(sort)
              })
          "
          :initSort="
            $route.query[`OtherPropertyInsuranceNoteSort`]
              ? JSON.parse($route.query[`OtherPropertyInsuranceNoteSort`])
              : null
          "
        >
          <template slot="contract_type" scope="item">{{
            translate.newContractType[item.data.contract_type]
          }}</template>
          <template slot="ceisdnm" scope="item">
            <span @click="routeToCustDetail(item.data.ceisdno , item.data.ceisdnm)">
              {{ item.data.ceisdnm | truncate }}
            </span>
          </template>
          <template slot="ceplcdt" scope="item">
            {{ item.data.ceplcdt | dateFormatStart}}
            <!-- <div
              class="pre-formatted"
              v-html="
                buildStartEndString(
                  getROCDate(item.data.ceplcdt),
                  getROCDate(item.data.celpsdt)
                )
              "
            ></div> -->
          </template>
          <template slot="famt" scope="item"
            >{{ Number(item.data.famt) | numberFormat }}元</template
          >
          <template slot="premium" scope="item"
            >{{ Number(item.data.premium) | numberFormat }}元</template
          >
          <template slot="remark" scope="item"
            >
            <div v-html="item.data.remark"></div>
            </template
          >
          <template slot="action" scope="item">
            <div class="dropdown">
              <a
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                class="btn btn-icon btn-default btn-sm"
                role="button"
              >
                <i class="icon-more"></i>
              </a>
              <div class="dropdown-menu">
                <a
                  role="button"
                  class="dropdown-item text-green text-underline"
                  @click="toUpdate(item.data.pt_contractx_id)"
                  >修改</a
                >
                <a
                  role="button"
                  class="dropdown-item text-green text-underline"
                  @click="doDelete(item.data)"
                  >刪除</a
                >
              </div>
            </div>
          </template>
        </data-table>
      </template>
    </data-section>
  </template>
  
  <script>
  import InsuranceMixins from "./Insurance";
  import HighlightModify from "./HighlightModify";
  import { contract_type_enum } from "@/desktop/contract/NewInsuranceContractTypes";
  import { deleteOtherPropertyInsurance } from "@/service";
  
  export default {
    mixins: [InsuranceMixins, HighlightModify],
    methods: {
      toUpdate(pt_contractx_id) {
        this.$router.push({
          name: "insurance-note",
          query: {
            pt_contractx_id
          }
        });
      },
      async doDelete(data) {
        await this.$deleteConfirm(
          `您是否要刪除此筆其他保單筆記「${data.ceplcno}」?`
          // this.buildDeleteMessage(
          //   `${data.ceplcno} ${contract_type_enum[data.contract_type]}`
          // )
        );
        await this.deleteSuccessHandler(
          deleteOtherPropertyInsurance({
            pt_contractx_id: data.pt_contractx_id
          })
        );
        this.isLoading = true;
        this.$bus.emit(
          "other-property-insurance.get",
          () => (this.isLoading = false)
        );
      }
    },
  };
  </script>
  